const clone = (value) => JSON.parse(JSON.stringify(value));

export const readLocalCollection = (storageKey, fallback = []) => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return clone(fallback);
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : clone(fallback);
  } catch {
    return clone(fallback);
  }
};

export const writeLocalCollection = (storageKey, items) => {
  localStorage.setItem(storageKey, JSON.stringify(items));
};

export const upsertLocalItem = (storageKey, item, idKey = '_id') => {
  const current = readLocalCollection(storageKey);
  const itemId = item?.[idKey];
  const next = itemId && current.some((entry) => String(entry?.[idKey]) === String(itemId))
    ? current.map((entry) => (String(entry?.[idKey]) === String(itemId) ? item : entry))
    : [...current, item];

  writeLocalCollection(storageKey, next);
  return next;
};

export const deleteLocalItem = (storageKey, id, idKey = '_id') => {
  const current = readLocalCollection(storageKey);
  const next = current.filter((entry) => String(entry?.[idKey]) !== String(id));
  writeLocalCollection(storageKey, next);
  return next;
};

export const createLocalId = (prefix) => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const normalizeStatus = (value) => (value ? 'Active' : 'Inactive');
